import type { FC, ReactNode } from 'react'
import { Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

import { ChevronLeft } from '@dhl/icons'

type Props = {
  children: ReactNode
  onClick?: () => void
  to?: string
}

export const BackButton: FC<Props> = ({ children, onClick, to }) => {
  const props = to ? { to, component: Link } : { onClick }

  return (
    <Button startIcon={<ChevronLeft />} variant="text" color="primary" data-test-id="back" {...props}>
      <Typography variant="h5">{children}</Typography>
    </Button>
  )
}
